__turbopack_context__.v({
  "accent": "TariffCard-module__Qaqrva__accent",
  "card": "TariffCard-module__Qaqrva__card",
  "cta": "TariffCard-module__Qaqrva__cta",
  "description": "TariffCard-module__Qaqrva__description",
  "disabled": "TariffCard-module__Qaqrva__disabled",
  "featureItem": "TariffCard-module__Qaqrva__featureItem",
  "featuresList": "TariffCard-module__Qaqrva__featuresList",
  "indicator": "TariffCard-module__Qaqrva__indicator",
  "marker": "TariffCard-module__Qaqrva__marker",
  "name": "TariffCard-module__Qaqrva__name",
  "offers": "TariffCard-module__Qaqrva__offers",
  "priceBase": "TariffCard-module__Qaqrva__priceBase",
  "priceCurrent": "TariffCard-module__Qaqrva__priceCurrent",
  "pricePeriod": "TariffCard-module__Qaqrva__pricePeriod",
  "priceSpecification": "TariffCard-module__Qaqrva__priceSpecification",
});
